/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonContingent,
    JsonContingentFromJSON,
    JsonContingentFromJSONTyped,
    JsonContingentToJSON,
} from './JsonContingent';

/**
 * 
 * @export
 * @interface ApiResultOfJsonContingent
 */
export interface ApiResultOfJsonContingent {
    /**
     * 
     * @type {JsonContingent}
     * @memberof ApiResultOfJsonContingent
     */
    data?: JsonContingent;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonContingent
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonContingent
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonContingent
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonContingent
     */
    result?: ApiResultOfJsonContingentResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonContingentResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonContingentFromJSON(json: any): ApiResultOfJsonContingent {
    return ApiResultOfJsonContingentFromJSONTyped(json, false);
}

export function ApiResultOfJsonContingentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonContingent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonContingentFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonContingentToJSON(value?: ApiResultOfJsonContingent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonContingentToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

